import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { TableColumn, DataFilter } from '../../../store';
import { MainService } from '../../../services';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit, OnChanges {

  @Input() title;
  @Input() columns: TableColumn[];
  @Input() filter: DataFilter;
  @Input() data: any[];

  filteredData: any[];

  constructor(
    private mainService: MainService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.filteredData = this.mainService.search(this.data, this.filter);
  }

  get allChecked() {
    return this.filteredData && this.filteredData.length && this.filteredData.every(x => x.checked);
  }

  set allChecked(value) {
    (this.filteredData || []).forEach(x => x.checked = value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/table/table.component.ts